export const vendiaTokens = {
  brand: {
    name: "Vendia",
    version: "1.1.0",
    source: "approved/vendia-brand-board-v1.png",
  },
  color: {
    master: {
      navy: "#00123D",
      ink: "#0A1223",
      slate: "#1A2333",
      muted: "#667085",
      surface: "#F5F7FA",
      white: "#FFFFFF",
    },
    quote: {
      600: "#00A86E",
      500: "#17B26A",
      200: "#90E8D7",
      50: "#E6FAF1",
    },
    pos: {
      600: "#1A73E8",
      500: "#3B82FF",
      200: "#D6E6FF",
      50: "#EEF4FF",
    },
    business: {
      600: "#6C3CFF",
      500: "#8B5CF6",
      200: "#E9D5FF",
      50: "#F4F0FF",
    },
    status: {
      success: "#00123D",
      info: "#1A2333",
      warning: "#B54708",
      danger: "#B42318",
      successSurface: "#00123D0F",
      infoSurface: "#1A23330F",
      warningSurface: "#B5470814",
      dangerSurface: "#B4231812",
    },
    semantic: {
      background: "#FFFFFF",
      surface: "#F5F7FA",
      text: "#0A1223",
      textMuted: "#667085",
      brand: "#00123D",
      quote: "#00A86E",
      pos: "#1A73E8",
      business: "#6C3CFF",
      success: "#00123D",
      info: "#1A2333",
      warning: "#B54708",
      danger: "#B42318",
    },
  },
  typography: {
    fontFamily: {
      primary: ["Sohne", "Inter", "Arial", "sans-serif"],
    },
    fontWeight: {
      light: 300,
      regular: 400,
      medium: 500,
      semibold: 600,
      bold: 700,
    },
    fontSize: {
      xs: "12px",
      sm: "14px",
      md: "16px",
      lg: "20px",
      xl: "24px",
      "2xl": "32px",
      "3xl": "48px",
    },
    lineHeight: {
      tight: 1.1,
      normal: 1.4,
      relaxed: 1.6,
    },
  },
  spacing: {
    1: "4px",
    2: "8px",
    3: "12px",
    4: "16px",
    6: "24px",
    8: "32px",
    12: "48px",
    16: "64px",
    24: "96px",
    32: "128px",
  },
  radius: {
    none: "0px",
    sm: "4px",
    md: "8px",
    lg: "12px",
    appIcon: "18px",
  },
  shadow: {
    sm: "0 1px 2px #00123D1A",
    md: "0 8px 24px #00123D24",
  },
  elevation: {
    surface: 1,
    overlay: 2,
  },
  size: {
    icon: {
      xs: "16px",
      sm: "24px",
      md: "32px",
      lg: "48px",
      xl: "64px",
      launcher: "512px",
    },
    logo: {
      compact: "96px",
      standard: "160px",
      large: "240px",
    },
  },
} as const;

export type VendiaTokens = typeof vendiaTokens;
